import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Button,
  Text,
} from '@razorpay/blade/components';

interface DiscardModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const DiscardModal = ({ isOpen, onCancel, onContinue }: DiscardModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onCancel}
      size="small"
      accessibilityLabel="Warning: Unsaved Changes">
      <ModalHeader title="Warning: Unsaved Changes" />

      <ModalBody>
        <Text size="medium" color="surface.text.gray.normal">
          If you leave now, your progress will be lost. Do you want to continue without saving, or
          stay and finish your updates?
        </Text>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="tertiary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="secondary" color="negative" onClick={onContinue}>
            Discard
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}; 